import { Badge } from '@/components/atoms';
import type { WhatsAppTemplateStatus } from '@/types/whatsapp-template';

const STATUS_VARIANT: Record<
  WhatsAppTemplateStatus,
  'warning' | 'success' | 'destructive'
> = {
  pending: 'warning',
  approved: 'success',
  rejected: 'destructive',
};

const STATUS_LABEL: Record<WhatsAppTemplateStatus, string> = {
  pending: 'Pending',
  approved: 'Approved',
  rejected: 'Rejected',
};

interface TemplateStatusBadgeProps {
  status: WhatsAppTemplateStatus;
}

export const TemplateStatusBadge = ({ status }: TemplateStatusBadgeProps) => (
  <Badge variant={STATUS_VARIANT[status]}>{STATUS_LABEL[status]}</Badge>
);
